import axios from "axios";
import store from "@/store";
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { removeAPIPrefix } from "../../utils/url";

let authServiceInstance = null
const subdomain = window.location.host.split('.')[0]
const addressAPIWithoutPrefix = removeAPIPrefix(process?.env?.VUE_APP_ARANDU_API_URL)
export const baseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + process?.env?.VUE_APP_ARANDU_API_URL
const reverbBaseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + addressAPIWithoutPrefix
const reverbSecretKey = process?.env?.VUE_APP_ARANDU_API_REVERB_KEY
const shouldInitializeReverb = Boolean(!authServiceInstance && addressAPIWithoutPrefix && subdomain && reverbSecretKey)
const authServiceReverb = () => authServiceInstance

const resetAuthServiceReverb = () => {
  if (authServiceInstance) {
    authServiceInstance.disconnect();

    if (authServiceInstance.connector?.socket) {
      authServiceInstance.connector.socket.close();
    }

    authServiceInstance = null
  }
}

const initializeAuthServiceReverb = (userToken) => {
  if (shouldInitializeReverb && userToken) {
    const reverbWsConnection = () => {
      if (process?.env?.VUE_APP !== 'localhost') {
        return `${subdomain}.${addressAPIWithoutPrefix}`
      }
      return 'localhost'
    }

    try {
      authServiceInstance = new Echo({
        broadcaster: 'reverb',
        key: reverbSecretKey,
        wsHost: reverbWsConnection(),
        wsPort: process?.env?.VUE_APP === 'localhost' ? 6001 : 80,
        wssPort: process?.env?.VUE_APP === 'localhost' ? 6001 : 443,
        forceTLS: window.location.protocol === 'https',
        path: '/app',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: `${reverbBaseURL}/broadcasting/auth`,
        auth: {
          headers: {
            Authorization: 'Bearer ' + userToken,
          },
        }
      })

    } catch (error) {
      console.error(error)
    }
  }
}

const AuthService = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
  },
});

AuthService.interceptors.request.use(
  (config) => {
    const token = store.getters.getToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

export {
  authServiceReverb,
  initializeAuthServiceReverb,
  resetAuthServiceReverb
}

export default AuthService;